import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { ChargeComponent } from './pages/charge/charge.component';
import { DestinationAccountComponent } from './pages/charge/components/destination-account/destination-account.component';
import { PaymentInfoComponent } from './pages/charge/components/payment-info/payment-info.component';
import { TransactionStatusComponent } from './pages/charge/components/transaction-status/transaction-status.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'destination-account',
    pathMatch: 'full',
  },
  {
    path: '',
    component: ChargeComponent,
    children: [
      { path: 'destination-account', component: DestinationAccountComponent },
      { path: 'payment-info/:cardno', component: PaymentInfoComponent },
      { path: 'transaction-status', component: TransactionStatusComponent }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
